export default __webpack_public_path__ + "static/media/Workout.e0b19015.svg";